var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgThumbsUpFilledicon = function SvgThumbsUpFilledicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.64 5.108a1.75 1.75 0 0 0-1.312-.592H9.27L9.5 3C9.781 1.14 8.593.725 7.964.75a.75.75 0 0 0-.67.414L5 5.75v8h7.75a1.75 1.75 0 0 0 1.736-1.533l.578-5.734a1.749 1.749 0 0 0-.424-1.375ZM3.5 13.75v-8H2A1.25 1.25 0 0 0 .75 7v5.5A1.25 1.25 0 0 0 2 13.75h1.5Z",
    clipRule: "evenodd"
  })));
};
export default SvgThumbsUpFilledicon;